import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RowWrappingClass;
function RowWrapping() {
  if (RowWrappingClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.vb5_1.zb3_1 = 'div';
        this.vb5_1.cb9('display', 'flex');
        this.vb5_1.cb9('flex-direction', 'row');
        this.vb5_1.cb9('flex-wrap', 'wrap');
        var tmp0 = this.vb5_1.jb4_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = 'kiteui-flex';
        tmp0.v(element);
        var tmp0_0 = this.vb5_1.jb4_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element_0 = 'kiteui-row-wrap';
        tmp0_0.v(element_0);
      }
      wb9(index, view) {
        super.wb9(index, view);
        var horizontalAlign = view.vb5_1.fb4_1;
        var verticalAlign = view.vb5_1.eb4_1;
        switch (horizontalAlign == null ? -1 : horizontalAlign.b4_1) {
          case 0:
            view.vb5_1.cb9('justify-self', 'start');
            break;
          case 1:
            view.vb5_1.cb9('justify-self', 'center');
            break;
          case 2:
            view.vb5_1.cb9('justify-self', 'end');
            break;
          default:
            view.vb5_1.cb9('justify-self', 'stretch');
            break;
        }
        switch (verticalAlign == null ? -1 : verticalAlign.b4_1) {
          case 0:
            view.vb5_1.cb9('align-self', 'start');
            break;
          case 1:
            view.vb5_1.cb9('align-self', 'center');
            break;
          case 2:
            view.vb5_1.cb9('align-self', 'end');
            break;
          default:
            view.vb5_1.cb9('align-self', 'stretch');
            break;
        }
      }
    }
    initMetadataForClass($, 'RowWrapping');
    RowWrappingClass = $;
  }
  return RowWrappingClass;
}
//region block: exports
export {
  RowWrapping as RowWrapping1cfo2cqk4jxme,
};
//endregion

//# sourceMappingURL=Column.commonHtml.mjs.map
